/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./Pagination.css";

import * as React from "react";

import { PaginationProps, PaginationState } from "./Pagination.types";


function preparePagingState(state?: PaginationState, itemsPerPage: number = 100, itemCount: number = 0, pg?: number): { page: number, pagesCount: number } {

   let pagesCount = Math.floor(itemCount / itemsPerPage) + (itemCount % itemsPerPage === 0 ? 0 : 1);
   let page = state?.page || pg || 1;

   if (page > pagesCount) page = pagesCount;

   return {
      page,
      pagesCount
   };

}


export default class Pagination extends React.Component<PaginationProps, PaginationState> {

   private componentClassName: string;

   constructor(props: PaginationProps) {

      super(props);

      this.componentClassName = "tk-pagination" + (this.props.componentName ? `-${this.props.componentName}` : "");


      let itemCount = this.props.itemCount || 0;
      if (itemCount < 0) itemCount = 0;

      let itemsPerPage = this.props.itemsPerPage || 100;
      if (itemsPerPage < 0) itemsPerPage = 0;

      this.state = {
         fastStep: 10,
         ...preparePagingState(undefined, itemsPerPage, itemCount,this.props.page)
      }


   }

   public static getDerivedStateFromProps(props: PaginationProps, state: PaginationState) {

      let itemCount = props.itemCount;
      if (itemCount < 0) itemCount = 0;

      let itemsPerPage = props.itemsPerPage;
      if (itemsPerPage < 0) itemsPerPage = 0;

      let page = props.page || state.page;
      if (page < 1) page = 1;
      if (page > state.pagesCount) page = state.pagesCount;

      let fastStep = props.fastStep || 10;
      if (fastStep < 2) fastStep = 2;

      const newState = {
         ...(preparePagingState(state, itemsPerPage, itemCount, page)),
         page,
         fastStep
      };

      return newState;

   }

   public render() {

      if (this.state.pagesCount < 2 && this.props.hideWhenNotNecessary) return <></>;

      const home = !this.props.hasHomeEnd || this.state.pagesCount < 2 ? <></> :
         <div className="nav" onMouseDown={() => this.setPage(1)}>|&lt;</div>

      const end = !this.props.hasHomeEnd || this.state.pagesCount < 2  ? <></> :
         <div className="nav" onMouseDown={() => this.setPage(this.state.pagesCount)}>&gt;|</div>

      const fastPrev = !this.props.hasFastMove || this.state.pagesCount < 2  ? <></> :
         <div className="nav" onMouseDown={() => this.setPage(this.state.page - this.state.fastStep > 0 ? this.state.page - this.state.fastStep : 1)}>&lt;&lt;</div>

      const fastNext = !this.props.hasFastMove || this.state.pagesCount < 2  ? <></> :
         <div className="nav" onMouseDown={() => this.setPage(this.state.page + this.state.fastStep <= this.state.pagesCount ? this.state.page + this.state.fastStep : this.state.pagesCount)}>&gt;&gt;</div>

      const prev = !this.props.hasPrevNext || this.state.pagesCount < 2  ? <></> :
         <div className="nav" onMouseDown={() => this.setPage(this.state.page - 1 > 0 ? this.state.page - 1 : 1 )}>&lt;</div>

      const next = !this.props.hasPrevNext || this.state.pagesCount < 2  ? <></> :
         <div className="nav" onMouseDown={() => this.setPage(this.state.page + 1 <= this.state.pagesCount ? this.state.page + 1 : this.state.pagesCount )}>&gt;</div>

      let pages: React.ReactNode[] = [];

      if (this.state.pagesCount < 8) {

         for (let i = 1; i <= this.state.pagesCount; i++) {
            pages.push(<div key={i} data-selected={this.state.page === i} className="button" onMouseDown={() => this.setPage(i)}>{i}</div>)
         }

      } else {

         pages.push(<div key={1} className="button" data-selected={this.state.page === 1} onMouseDown={() => this.setPage(1)}>{1}</div>)

         for (let i = 0; i < 5 && i <= this.state.pagesCount; i++) {
            if (i === 0 && this.state.page > 4) {
               pages.push(<div key="n1" className="nav">...</div>)
            } else {
               let idx = i;

               if (this.state.page < 5) {
                  idx += 2;
               } else if (this.state.page > this.state.pagesCount - 4) {
                  idx += this.state.pagesCount - 5;
               } else {
                  idx += this.state.page - 2;
               }

               if (i === 4 && idx < this.state.pagesCount - 1) {
                  pages.push(<div key="n2" className="nav">...</div>)
               } else {
                  pages.push(<div key={idx} className="button" data-selected={this.state.page === idx} onMouseDown={() => this.setPage(idx)}>{idx}</div>)
               }
            }
         }

         pages.push(<div key={this.state.pagesCount} className="button" data-selected={this.state.page === this.state.pagesCount} onMouseDown={() => this.setPage(this.state.pagesCount)}>{this.state.pagesCount}</div>)
      }


      return (

         <div className={this.componentClassName}>

            {home}
            {fastPrev}
            {prev}

            <div></div>

            {pages}

            <div></div>

            {next}
            {fastNext}
            {end}

         </div>

      )

   }

   private setPage(page: number) {
      if (page === this.state.page) return;
      this.setState({ page });
      if (this.props.onChange) this.props.onChange(page);
   }

}